// Shared bits of the biometric device screens (Devices, Live Punches, Unmatched Punches, Device Log).

export const STATE_TONE = { 'Pending Approval': 'yellow', Active: 'green', Disabled: 'gray' };
export const CONN_TONE = { Online: 'green', Offline: 'red', 'Never Connected': 'gray' };
export const ROSTER_TONE = { Pending: 'yellow', Synced: 'green', Failed: 'red', Removed: 'gray' };
export const CMD_TONE = { Queued: 'yellow', Sent: 'teal', Done: 'green', Failed: 'red', Cancelled: 'gray' };
export const TIMEZONES = ['Africa/Lagos', 'Africa/Accra', 'Africa/Abidjan', 'Africa/Johannesburg', 'Africa/Nairobi', 'Africa/Cairo', 'UTC', 'Europe/London'];

// date as the browser writes it, time always in 12-hour form: "4 Nov 2026, 2:15:49 AM"
export const dt = s => {
  if (!s) return '—';
  const d = new Date(s);
  return `${d.toLocaleDateString(undefined, { dateStyle: 'medium' })}, ${d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true })}`;
};

export { t12 } from '../../format';   // 12-hour times, shared with the attendance screens

// "12s ago", "5 min ago", "3 h ago", or the date
export const ago = s => {
  if (!s) return '—';
  const sec = Math.max(0, Math.round((Date.now() - new Date(s).getTime()) / 1000));
  if (sec < 60) return `${sec}s ago`;
  if (sec < 3600) return `${Math.floor(sec / 60)} min ago`;
  if (sec < 86400) return `${Math.floor(sec / 3600)} h ago`;
  return new Date(s).toLocaleDateString();
};

// refresh a screen on a timer while it is open and the tab is visible
export const every = (ms, fn) => {
  const t = setInterval(() => { if (!document.hidden) fn(); }, ms);
  return () => clearInterval(t);
};

// device clock offset: "on time", "3 min fast", "2 h slow"
export const clockText = sec => {
  const a = Math.abs(sec);
  if (a < 60) return 'On time';
  const v = a < 3600 ? `${Math.round(a / 60)} min` : `${(a / 3600).toFixed(1)} h`;
  return `${v} ${sec > 0 ? 'fast' : 'slow'}`;
};
